import { Box, Button, Dialog, Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useRef, useState } from 'react';
import DialogHeader from '../DialogHeader';
import AddAssociatedTeamMembers from './AddAssociatedTeamMembers';
import { useDispatch } from 'react-redux';
import StyledDialog from '../../../../../common/models/Dialog';
import { DESTROY_BACKDROP, OPEN_BACKDROP } from '../../../../containers/actions/types';

const useStyles = makeStyles((theme) => ({
  list: {
    width: '40vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      width: '80vw',
    },
  },
  backdrop: {
    '& .MuiBackdrop-root ': {
      backgroundColor: 'transparent !important',
      opacity: '0 !important',
    },
  },
}));

const UpdateTeamMembers = (props) => {
  const { warehouseDetails, handleClose, handleCloseAllDialogBox } = props;
  const classes = useStyles();
  const [selectedTeamMembers, setSelectedTeamMembers] = useState(warehouseDetails?.associatedTeamMembers ? warehouseDetails?.associatedTeamMembers : [] );
  const dispatch = useDispatch();
  const errorRef = useRef();
  
  const [mainError, setmainError] = useState('');
  const [fieldError, setFieldError] = useState(null);
  const [addedSuccessfull, setAddedSuccessfull] = useState(false);


  const handleChangeTeamMemberList = (val) => {
    setmainError('');
    setFieldError(null);
    setSelectedTeamMembers(val)
  }

  const validate = () => {
      let validated = true;
      let errors = null;
      if (!selectedTeamMembers || selectedTeamMembers.length === 0 ) {
        setFieldError({
          ...errors,
          associatedTeamMembers: 'Select associated team members',
        })
        validated = false;
      }
  
      return validated;
    }
  
    const handleSaveTeamMembers = () => {
      const validated = validate();
      
      if (validated) {
        dispatch({
          type: OPEN_BACKDROP,
          backdropText: 'Please wait...',
        });
        setTimeout(() => {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          // setmainError('Something went wrong. Please try again.')
          // errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setAddedSuccessfull(true)
        },3000)
      } else {
          setmainError('Enter the mandatory fields')
          errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      
  }
  

  const handleCloseSave = () => {
    setAddedSuccessfull(false);
    handleClose();
    handleCloseAllDialogBox();
  }

  return (
    <React.Fragment>
      <div className={classes.list}>
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        style={{ padding: '1rem' }}
      >
        <Grid ref={errorRef} item xs={12}>
          <DialogHeader header={'Update team members'} />
        </Grid>
        <Grid container spacing={2}>
          {mainError &&
                      <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center", // Horizontally center the CircularProgress
                                    alignItems: "center", // Vertically center the CircularProgress
                                    height: "50px", // Optional: Set a height to vertically center the loader
                                    border: "2px solid #FF0000",
                                    backgroundColor: "#FFF0F0",
                                    width: "100%",
                                  }}
                                >
                                  <Typography style={{ textAlign: "center" }}>
                                    {mainError}
                                  </Typography>
                                </div>
          }
          
          <Grid item xs={12}>
            <Typography
              style={{
                whiteSpace: 'nowrap',
                fontSize: '1.5rem',
                fontWeight: '500',
                paddingBottom: '10px',
                justifySelf: 'flex-start',
              }}
            >
              {warehouseDetails.warehouseName}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <AddAssociatedTeamMembers selectedTeamMembers={selectedTeamMembers} handleChangeTeamMemberList={handleChangeTeamMemberList} errors={fieldError} />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        style={{ padding: '1rem' }}
      >
        <Grid item xs={12}>
        <Typography
        style={{
          fontWeight: "500",
          marginBottom: "8px",
          color: "black",
        }}
      >
        Warning:
          </Typography>
          <Box
      display="flex"
      flexDirection="column"
      border="1px solid #f44336"
      borderRadius="4px"
      padding="16px"
      bgcolor="#fff"
    >
      <Typography
        variant="body2"
        style={{
          color: "#f44336",
        }}
      >
        Associated team members change: You are changing the list of team members associated with the warehouse. Team members may lose access to the warehouse specific information.
      </Typography>
    </Box>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '1rem',
            alignContent: 'flex-end',
          }}
        >
        <Button
          variant='outlined'
          style={{ textTransform: 'none' }}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          color='secondary'
              style={{ textTransform: 'none' }}
              onClick={()=>handleSaveTeamMembers()}
        >
          Save Changes
        </Button>

        </Grid>
      </Grid>
      </div>
      
      <Dialog open={addedSuccessfull} fullWidth>
                    <StyledDialog
                      icons={true}
                      handleClose={handleCloseSave}
                      title={'Updated team members successfully'}
                    />
                  </Dialog>
    </React.Fragment>
    
  );
};

export default UpdateTeamMembers;
